/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum WebSocketConnections {
    Terminal = 'terminal',
    NotificationBell = 'notificationBell',
}
